import { XMLInterfaceObject } from "@goodgamestudios/core";
import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { Poker2Model } from "../model/Poker2Model";
import { VisualVO } from "./VisualVO";

export class ShopVO extends VisualVO {
    public itemCategory: string;
    public shopCategoryMain: string;
    public shopCategorySecondary: string;
    public priceGold: number = NaN;
    public priceChips: number = NaN;
    public priceFriends: number = NaN;
    public availability: string;
    /** The unlockDate in the itemXML comes as timestamp in seconds. It will be stored in milliseconds. **/
    public unlockDate: number = NaN;

    constructor() {
        CONSTRUCTOR_HACK;
        super();
    }

    public fillFromParamXML(wodElement: XMLInterfaceObject): void {
        super.fillFromParamXML(wodElement);
        this.itemCategory = (wodElement['itemCategory'] || '');
        this.shopCategoryMain = (wodElement['shopCategoryMain'] || '');
        this.shopCategorySecondary = (wodElement['shopCategorySecondary'] || '');
        this.priceGold = parseFloat((wodElement['priceGold'] || ''));
        this.priceChips = parseFloat((wodElement['priceChips'] || ''));
        this.priceFriends = parseFloat((wodElement['priceFriends'] || ''));
        this.availability = (wodElement['availability'] || '');

        var unlockDateInt: number = Number((wodElement['unlockDate'] || ''));
        if (!isNaN(unlockDateInt) && unlockDateInt > 0) {
            // flash uses milliseconds
            this.unlockDate = unlockDateInt * 1000;
        }
    }

    public isItemAvalibleByEvent(shopState: string = ""): boolean {
        if (shopState == "stateInventory" && this.availability == "NOT_IN_SHOP") {
            return true;
        }

        if (this.availability == "always") {
            return true;
        }

        for (let entryList of Poker2Model.sessionData.currentEvents) {
            var currentEventId: any = entryList;
            if (currentEventId === undefined) continue;

            if (this.availability == currentEventId)
                return true;
        }
        return false;
    }
}
import { Poker2ShopScreen } from "../view/screens/Poker2ShopScreen";
classImplementsInterfaces(ShopVO, "IInventoryVO");
